import { defaultDigestSlice } from '../default-digest-slice';
import { filterInvalidDigestLinks, getDefaultDigestLinks } from '../utils';

import type { DigestHighlightsSliceType } from '../types';

export interface GetDefaultDigestSliceArgs {
  slice: DigestHighlightsSliceType | undefined;
  buildId: string;
}

export function getDefaultDigestSlice({
  slice,
  buildId,
}: GetDefaultDigestSliceArgs) {
  const digestSlice = slice ?? defaultDigestSlice;

  const validExistingLinks = filterInvalidDigestLinks(digestSlice.items);

  const defaultDigestLinks = getDefaultDigestLinks({
    numExistingLinks: validExistingLinks.length,
    buildId,
  });

  return {
    ...digestSlice,
    items: [...validExistingLinks, ...defaultDigestLinks],
  };
}
